import api from './api';

export interface VayHoanCongDto {
  id: number;
  maChamCong: string;
  tenNV?: string;
  thangNguon: number;
  namNguon: number;
  thangDich: number;
  namDich: number;
  soNgayDieuChinh: number;
  lyDo?: string;
  ngayTao?: string;
  ngaySua?: string;
  nguoiTao?: string;
  nguoiSua?: string;
}

export interface VayHoanCongSaveRequest {
  id?: number | null;
  maChamCong: string;
  thangNguon: number;
  namNguon: number;
  thangDich: number;
  namDich: number;
  soNgayDieuChinh: number;
  lyDo?: string;
}

export const vayHoanCongService = {
  getByKy: async (maChamCong: string, thang: number, nam: number): Promise<VayHoanCongDto | null> => {
    const response = await api.get('/VayHoanCong/get-by-ky', {
      params: { maChamCong, thang, nam }
    });
    return response.data || null;
  },

  getTongDieuChinhKy: async (maChamCong: string, thang: number, nam: number): Promise<number> => {
    const response = await api.get('/VayHoanCong/tong-dieu-chinh-ky', {
      params: { maChamCong, thang, nam }
    });
    return response.data?.value ?? 0;
  },

  luu: async (request: VayHoanCongSaveRequest): Promise<void> => {
    await api.post('/VayHoanCong/luu', request);
  },
};
